
import { Component, Vue, Prop} from 'vue-property-decorator';

import StepBase from "../StepBase.vue";
import { stepInfoType } from "@/types/Application";
import Land from "./Land.vue";
import Vehicles from "./Vehicles.vue";
import BankAccounts from "./BankAccounts.vue";
import Pension from "./Pension.vue";
import PersonalItems from "./PersonalItems.vue";


@Component({
    components:{
        StepBase,
        Land,
        Vehicles,
        BankAccounts,
        Pension,
        PersonalItems
    }
})
export default class BelongingsStep extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

};
